import api from "../../config/client.axios.api";

export const getDetailErrorTransactionApi = async (
  accountId: string,
  startDate: string,
  endDate: string,
  storeCode: string,
  page: any,
  resultId: any
) => {
  const response = await api.get(`/record-transaction/detail-count-error`, {
    params: {
      accountId: accountId && accountId,
      startDate,
      endDate,
      storeCode,
      page,
      size: 10,
      resultId,
    },
  });
  return response.data;
};
